import { c as _c } from "react/compiler-runtime";
import { IcoChevronDown16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';

// Shared with the inline controls that look like a chip but don't open a menu.
// A two-word type ("list of objects") must not wrap: a two-line chip knocks its row out of alignment.
export const CHIP_CLASS_NAME = 'inline-flex max-w-full items-center gap-0.5 whitespace-nowrap rounded border border-tertiary bg-primary px-1.5 py-0.5 text-snippet-3 text-tertiary';
type TypeChipProps = {
  label: string;
  canEdit?: boolean;
};
const TypeChip = t0 => {
  const $ = _c(10);
  const {
    label,
    canEdit: t1
  } = t0;
  const canEdit = t1 === undefined ? true : t1;
  const t2 = canEdit && "transition-colors duration-100 hover:bg-hover-control";
  let t3;
  if ($[0] !== t2) {
    t3 = cx(CHIP_CLASS_NAME, t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== label) {
    t4 = <span className="min-w-0 truncate">{label}</span>;
    $[2] = label;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== canEdit) {
    t5 = canEdit && <span className="[&>svg]:h-3 [&>svg]:w-3"><IcoChevronDown16 color="tertiary" /></span>;
    $[4] = canEdit;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = <span className={t3}>{t4}{t5}</span>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
export default TypeChip;